import React, { useCallback } from 'react'
import { Formik } from 'formik'
import * as Yup from 'yup'

import { Typography, Button, Container } from '../../components'

import * as S from './styles'
import { Form, FormBody, FormFooter } from '../../components/Form/styles'
import Input from '../../components/Form/Input'
import { DefaultRegularPages } from '../DefaultPages'

import loginImg from '../../assets/Images/loginImg.png'
import ecbrBadge from '../../assets/Icons/ecbrBadge.svg'
import ErrorMessage from '../../components/Form/ErrorMessage'
import useQueryParams from '../../hooks/useQueryParams'
import history from '../../store/history'
import { useSelector } from 'react-redux'
import { loginActions } from '../../redux/ducks/login'
import useActions from '../../hooks/useActions'
import { ErrorMessages } from '../../constants/defaultMessages'

const initialValues = {
  email: '',
  password: ''
}

const formSchema = Yup.object().shape({
  email: Yup.string().required('Campo obrigatório').email('Email inválido'),
  password: Yup.string().required('Campo obrigatório')
})

const Login = () => {
  const redirect = useQueryParams().get('redirect')
  const errorMsgCode = useQueryParams().get('errMsgCode')
  const actions = useActions(loginActions)
  const loginState = useSelector((state) => state.login)

  const onSubmit = useCallback(
    async (values, { setSubmitting }) => {
      setSubmitting(true)

      const logged = await actions.login(values.email, values.password)

      if (!logged) {
        setSubmitting(false)
        return
      }

      if (redirect) {
        history.push(redirect)
      } else {
        history.push('/user')
      }

      setSubmitting(false)
    },
    [actions, redirect]
  )

  return (
    <DefaultRegularPages>
      <Container>
        <S.Container>
          <S.LogoContainer>
            <S.LogoWrapper backgroundImage={loginImg}>
              <img src={ecbrBadge} alt="ecbrDNA" />
            </S.LogoWrapper>
          </S.LogoContainer>
          <S.LoginContainer>
            <Typography type="h2" color="#151515" spacing="32px 0 0 0">
              Login
            </Typography>
            <Typography type="text" color="#7D7987" spacing="32px 0 0 0">
              Olá, seja bem vindo :)
            </Typography>

            <Formik
              initialValues={initialValues}
              validationSchema={formSchema}
              onSubmit={onSubmit}
            >
              {({ isSubmitting }) => (
                <Form>
                  <FormBody>
                    <Input
                      name="email"
                      label="Email de acesso"
                      showValidIcon
                      display="inline-block"
                    />
                    <Input
                      name="password"
                      type="password"
                      label="Senha"
                      display="inline-block"
                    />
                    <S.FlexEndContainer>
                      <S.ForgotPassword to="/recovery">
                        Esqueceu a senha?
                      </S.ForgotPassword>
                    </S.FlexEndContainer>
                    <ErrorMessage>{loginState.formError}</ErrorMessage>
                    {errorMsgCode && (
                      <ErrorMessage>{ErrorMessages[errorMsgCode]}</ErrorMessage>
                    )}
                  </FormBody>
                  <FormFooter>
                    <S.FooterContainer>
                      <Button
                        text="ENTRAR"
                        type="submit"
                        variant="primary"
                        width="200px"
                        disabled={isSubmitting}
                      />
                      <S.ContainerWithoutAccountParagraph>
                        <S.WithoutAccountParagraph>
                          Não tem uma conta?
                        </S.WithoutAccountParagraph>
                        <S.WithoutAccountParagraphCreateAccount
                          onClick={() => history.push('/signup')}
                        >
                          Crie sua conta
                        </S.WithoutAccountParagraphCreateAccount>
                      </S.ContainerWithoutAccountParagraph>
                    </S.FooterContainer>
                  </FormFooter>
                </Form>
              )}
            </Formik>
          </S.LoginContainer>
        </S.Container>
      </Container>
    </DefaultRegularPages>
  )
}

export default Login
